'use strict'

import React, { Suspense, lazy, memo } from 'react'

import creators from '../assets/noun-project-creators.json'
const NounProjectCreator = lazy(() => import('./NounProjectCreator'))

const Footer = () => {
  return (
    <footer className='footer mt-5 py-4'>
      <div className='container'>
        <div className='row'>
          <div className='col text-center'>
            <span className='made-by'>
              Made with&nbsp;
              <span className='love mt-1'>&#9829;</span>&nbsp; by&nbsp;
              <a
                href='https://jagonzalr.com'
                rel='noopener noreferrer'
                target='_blank'
              >
                jagonzalr
              </a>
            </span>
          </div>
        </div>
        <div className='row mt-3'>
          <div className='col text-center'>
            {creators.map(({ icon, iconUrl, author, authorUrl }) => (
              <Suspense key={iconUrl} fallback={<span />}>
                <NounProjectCreator
                  icon={icon}
                  iconUrl={iconUrl}
                  author={author}
                  authorUrl={authorUrl}
                />
              </Suspense>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default memo(Footer)
